import {
  Box,
  Card,
  CardContent,
  Typography,
  Grid,
  Autocomplete,
  TextField,
  Button,
  Checkbox,
  Switch,
  ListItemText
} from "@mui/material";
import React, {useEffect, useState} from "react";
import { useRemoteConfig } from "providers";
import { useSelector, useDispatch } from 'react-redux';
import { useLocation } from "react-router-dom";
import { convertStringToArray, convertStringToObject } from "utils/rcUtils";
import Snack from "components/Snack";
import Skeleton from "./skeleton"; 
import _ from "lodash";
import {skpRegionRoles, getModifiedRegions} from '../utils';
import { updateIMWarehouseAccess } from "redux/actions/addEditWorker";

const IMWarehouse = ({handleChange}) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const workerData = location.state && location.state.worker ? location.state.worker : null;
  const empId = location.state && location.state.empId ? location.state.empId : '';
  const approveForMgr = location.state && location.state.approveForManager
                            ? location.state.approveForManager : {};
  const imWarehouseRegions = useRemoteConfig("region", "imWarehouse");
  const imWarehouseCountries = useRemoteConfig("imWarehouseCountries");
  const { user } = useSelector((state) => state.user.auth);
  const imWarehouse = useSelector(state => state.addEditWorker.workerRoles.imWarehouse);
  const loadingRoles = useSelector(state => state.addEditWorker.loadingRoles);
  const imtRole = useSelector((state) => state.user.imtRole || null);
  const [regions, setRegions] = useState({});
  const [warehouseCountries, setWarehouseCountries] = useState([]);
  const [formValues, setFormValues] = useState({});
  const [selectedRegion, setSelectedRegion] = useState({});
  const [formErrors, setFormErrors] = useState({});
  console.log("warehouse selectedRegion", selectedRegion);
  const [snackControl, setSnackControl] = useState({ open: false, message: "", severity: 'success' });
  const [disableSave, setDisableSave] = useState(true);
  const [readOnly, setReadOnly] = useState(true);

  useEffect(() => {
    console.log("IMTime Role", imtRole)
    if(imtRole?.userRole?.role !== "Support"){
          setReadOnly(false);
      }
  },[imtRole])

    useEffect(() => {
          let rcRegions;
          if (user.country) {
            let countries = convertStringToArray(imWarehouseCountries);
             //console.log("warehouse", countries)
            countries = countries.toString().toLowerCase().split(",");
            setWarehouseCountries(countries);
          //  if (countries.includes(user.country.toLowerCase())) {
              rcRegions = convertStringToObject(imWarehouseRegions);
              // console.log("getWarehouse", rcRegions);
              const systems = Object.keys(rcRegions);
              // console.log("Warehouse", systems);
              let initialSelectedRegion = {};
              systems.map((item) => {
                initialSelectedRegion[item] = [];
              });
              rcRegions.systems = systems;
              setRegions(rcRegions);
              console.log("Warehouse", rcRegions);
              setSelectedRegion(initialSelectedRegion);
           // }
          }
    }, [user])

    useEffect(() => {

      console.log("warehouse workerRoles", imWarehouse)
      if (imWarehouse && regions?.systems) {
        // Create a deep copy of imWarehouse to ensure immutability
        let initialFormValues = { ..._.cloneDeep(imWarehouse) };
        let initialSelectedRegions = {};
      
        // Iterate through regions.systems array
        regions.systems.forEach(activityFamilyId => {
          // Initialize the selected regions for this activityFamilyId
          if (!initialSelectedRegions[activityFamilyId]) {
            initialSelectedRegions[activityFamilyId] = [];
          }
      
          const systemRegions = regions[activityFamilyId]; // Get the regions for this activityFamilyId
          const data = imWarehouse[activityFamilyId]; // Get the data for this activityFamilyId
      
          // Ensure systemRegions and data are valid before processing
          if (systemRegions?.length > 0 && data) {
            systemRegions.forEach(region => {
              // Check if the region exists and is active in the data
              if (data[region]?.isActive) {
                initialSelectedRegions[activityFamilyId].push(region);
              }
            });
          }
        });
        console.log(initialSelectedRegions);
        setSelectedRegion(initialSelectedRegions);
        setFormValues({...initialFormValues});  // Output the selected regions
      }


    }, [imWarehouse, regions])

    useEffect(() => {
        validForm(formValues)
    }, [formValues, selectedRegion])

    const validForm = (formValues) => {
      let errors = {};
      let errorStatus = false;
      if (selectedRegion && formValues && imWarehouse) {
        Object.keys(selectedRegion).forEach(activityFamily => {
          // Ensure that errors[activityFamily] is initialized
          if (!errors[activityFamily]) {
            errors[activityFamily] = {};
          }
      
          selectedRegion[activityFamily].forEach(region => {
            // Get userId and role from formValues
            let userId = formValues?.[activityFamily]?.[region]?.userId;
            let role = formValues?.[activityFamily]?.[region]?.role;
      
            // Initialize errors[activityFamily][region] if not already done
            if (!errors[activityFamily][region]) {
              errors[activityFamily][region] = {};
            }
      
            // Validate userId
            if (!userId) {
              errors[activityFamily][region].userId = "UserId is required";
              errorStatus = true;
            }
      
            // Validate role if activityFamily is "SKP"
            if (activityFamily === "SKP" && region !== "AMER" && !role) {
              errors[activityFamily][region].role = "Role is required";
              errorStatus = true;
            }
          });

        });
      }  
      setFormErrors({...errors});
      const isFormChanged = !_.isEqual((imWarehouse || {}), formValues);
      let isValidForm = !errorStatus && isFormChanged;
      console.log("warehouse errors", formValues, isValidForm);
      setDisableSave(!isValidForm);
      return isValidForm;
    }

    const handleCloseSnack =  () => {
      setSnackControl(state => ({...state, open:false, message: ""}));
    }

    const handleSubmit = async (e) => {
      try{
      e.preventDefault();
      const isValid = validForm(formValues);
      if(!isValid || !user.workerId){
        setSnackControl({
          severity:'error',
          message:"Invalid data. Please check.",
          open: true
        })
        return ;
      }
      console.log("warehouse submit", formValues, imWarehouse);
      const {updatedForm, updatedRegions, isEnabled} = getModifiedRegions(formValues, imWarehouse, regions);
      if(Object.keys(updatedRegions).length > 0){
        console.log("warehouse submit", updatedRegions,  updatedForm);
      const response = await dispatch(updateIMWarehouseAccess(
                                         updatedRegions, 
                                         workerData.workerId, 
                                         user?.workerId,  
                                         updatedForm, 
                                         regions.systems,
                                         isEnabled
                                        ));
        if(response && response.status){
          setSnackControl({
            severity:'success',
            message:"IM Warehouse Access updated successfully.",
            open: true
          })
        }else{
          setSnackControl({
            severity:'error',
            message:"IM Warehouse Access failed to update.",
            open: true
          })
        }
      }else{
        setSnackControl({
          severity:'error',
          message:"No changes in the data to update.",
          open: true
        })
      }
      console.log("warehouse updatedRegions", updatedRegions);
      }catch(error){
        console.log("warehouse handleSubmit error", error);
      }
    }

  return (
    <>
      <Box>
        <form action="" id="formData">
           <Snack 
              openSnack={snackControl?.open} 
              severity={snackControl?.severity} 
              message={snackControl?.message} 
              handleCloseSnack={handleCloseSnack}>
            </Snack>
            <Card sx={{ overflow: "auto", width: "100%", height:'calc(100vh - 160px)'}}>
          {loadingRoles ? <Skeleton /> : (
              <CardContent
                style={{ marginLeft: "0%", border: "none", paddingTop: 40 }}
              >
                <Typography variant="h5" color="#616161" marginBottom={3}>
                  IM Warehouse
                </Typography>
                <hr id="customHr2" />
                <Grid container marginTop={3} paddingLeft={3}>
                {regions && regions?.systems && regions?.systems.length > 0 && 
                  regions?.systems.map(activityFamilyId => (
                    <>       
                      <Grid container spacing={3}  marginBottom={3}>
                        <Grid item xs={6} md={6} lg={3}>
                          <Autocomplete
                            key={activityFamilyId}
                            renderInput={(params) => (
                              <TextField {...params} label={`${activityFamilyId} User`} required />
                            )}
                            id={`${activityFamilyId}User`}
                            name={`${activityFamilyId}User`}
                            size="small"
                            disableCloseOnSelect
                            multiple
                            value={selectedRegion[activityFamilyId] || []}
                            options={regions[activityFamilyId] || []}
                            renderOption={(props, option, { selected }) => (
                              <li {...props}>
                                <Checkbox checked={selected}  />
                                <ListItemText primary={option} />
                              </li>
                            )}
                            onChange={(event, value) => {
                              setSelectedRegion(prevState => ({
                                ...prevState,
                                [activityFamilyId]: value ? value : []
                              }))
                              setFormValues(prevState => ({
                                ...prevState,
                                selectedRegions: {
                                  ...prevState.selectedRegions || {},
                                  [activityFamilyId]: value ? value : []
                                }
                              }))
                            }}
                            readOnly={readOnly}
                            disabled={readOnly}
                          />
                        </Grid>
                        <Grid container item sx={{ maxWidth: '600px' }}>
                          {regions && regions[activityFamilyId] && regions[activityFamilyId].length > 0 &&
                          regions[activityFamilyId].map(region => (
                            <>
                              <Grid  
                                marginBottom={3} 
                                item xs={6} 
                                sx={{display: selectedRegion?.[activityFamilyId]?.includes(region) ? '' : 'none'}}
                              >
                                <TextField
                                  key={`${region}UserId`}
                                  required
                                  label={`${region} User Id`}
                                  id={`${region}UserId`}
                                  name={`${region}UserId`}
                                  size="small"
                                  value={formValues?.[activityFamilyId]?.[region]?.userId || ""}
                                  error={formErrors?.[activityFamilyId]?.[region]?.userId}
                                  helperText={formErrors?.[activityFamilyId]?.[region]?.userId}
                                  onChange={e => {
                                    const value = e.target.value? e.target.value.trim() : "";
                                    setFormValues(prevState => ({
                                      ...prevState, 
                                      [activityFamilyId]: {
                                        ...(prevState?.[activityFamilyId] || {}),  // Safely access activityFamilyId
                                        [region]: {
                                          ...(prevState?.[activityFamilyId]?.[region] || {}),  // Safely access region
                                          userId: value  // Set userId to the new value
                                        }
                                      }
                                    }));                                    
                                  }}
                                  inputProps={{readOnly: readOnly}}
                                  disabled={readOnly}
                                />
                            </Grid>
                            {activityFamilyId && activityFamilyId === "SKP" && (
                              <Grid
                                marginBottom={3} 
                                item xs={6} 
                                sx={{display: selectedRegion?.[activityFamilyId]?.includes(region) ? '' : 'none'}}
                              >
                              <Autocomplete
                                key = {`${region}RoleId`}
                                sx={{ width: 210 }}
                                renderInput={(params) => (
                                  <TextField 
                                    {...params} 
                                    label={`${region} Role`} 
                                    required = { region !== "AMER" }
                                    error={formErrors?.[activityFamilyId]?.[region]?.role}
                                    helperText={formErrors?.[activityFamilyId]?.[region]?.role}
                                    />
                                )}
                                id={`${region}RoleId`}
                                name={`${region}RoleId`}
                                size="small"
                                options={skpRegionRoles}
                                value={formValues?.[activityFamilyId]?.[region]?.role || ""}
                                onChange={(e, v) => {
                                  let value = v ? v : "";
                                  setFormValues(prevState => ({
                                    ...prevState, 
                                    [activityFamilyId]: {
                                      ...(prevState?.[activityFamilyId] || {}),  // Safely access activityFamilyId
                                      [region]: {
                                        ...(prevState?.[activityFamilyId]?.[region] || {}),  // Safely access region
                                        role: value  // Set userId to the new value
                                      }
                                    }
                                  }));      
                                }}
                                readOnly={readOnly}
                                disabled={readOnly}
                              />
                            </Grid>
                            )}
                            </>
                          ))
                          }
                        </Grid>
                      </Grid>
                    </>
                  ))
                }
                </Grid>
                <Grid
                  item
                  xs={9}
                  style={{ marginTop: "2%", textAlign: "right", marginLeft: 4 }}
                >
                  <div>
                    <Button
                      size="medium"
                      variant="outlined"
                      onClick={(e) => handleChange(e, 0)}
                      style={{ marginRight: 10, display: readOnly ? "none" : "" }}
                    >
                      Cancel
                    </Button>
                    <Button
                      style={{display: readOnly ? "none" : ""}}
                      size="medium"
                      variant="contained"
                      id="svBtn"
                      disabled = {disableSave}
                      onClick={handleSubmit}
                    >
                      Save
                    </Button>
                  </div>
                </Grid>
              </CardContent>
          )}
            </Card>
        </form>
      </Box>
    </>
  );
};

export default IMWarehouse;
